<template>
  <v-card
    v-if="exercise.type === 'exercise' || exercise.type === 'pause' || exercise.type === 'superset'"
    color="grey lighten-4"
    rounded="lg"
    class="px-3 py-2 hoverable-card mb-2"
  >
    <v-row
      align="center"
      no-gutters
    >
      <v-col>
        <div v-if="exercise.type === 'pause'">
          {{ $t('training_builder.exercises.pause') }}
        </div>
        <div v-else-if="exercise.type === 'superset'">
          {{ $t('training_builder.superset') }} x{{ exercise.params.NMSR }}
        </div>
        <div v-else-if="exercise.type === 'exercise'">
          {{ exercise.name }}
        </div>
        <div
          v-if="exercise.type === 'superset' && exercise.exercises.length > 0"
          class="mt-1"
        >
          <v-chip
            v-for="supersetExercise in exercise.exercises"
            :key="exercise.id + supersetExercise.id"
            label
            x-small
            outlined
          >
            {{ supersetExercise.type === 'pause' ? $t('training_builder.exercises.pause') : supersetExercise.name }}
          </v-chip>
        </div>
      </v-col>
      <v-col cols="auto">
        <validation-provider
          v-slot="{ errors }"
          rules="time"
        >
          <v-text-field
            v-model="exercise.exercise_start_at"
            v-mask="'##:##:##'"
            outlined
            dense
            hide-details
            background-color="white"
            :label="$t('text_input.exercise.start_at')"
            style="width: 140px"
            :error-messages="errors"
            :placeholder="placeholderStart"
            @blur="formatStart()"
          />
        </validation-provider>
      </v-col>
      <v-col
        cols="auto"
        class="px-3"
      >
        -
      </v-col>
      <v-col cols="auto">
        <validation-provider
          v-slot="{ errors }"
          rules="time"
        >
          <v-text-field
            v-model="exercise.exercise_stop_at"
            v-mask="'##:##:##'"
            outlined
            dense
            hide-details
            background-color="white"
            :label="$t('text_input.exercise.stop_at')"
            style="width: 140px"
            :error-messages="errors"
            :placeholder="placeholderEnd"
            @blur="formatStop()"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'

export default {
  name: 'ExercisePeriodEntryRow',
  mixins: [deleteConfirmationMixin],
  props: {
    exercise: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    placeholderStart() {
      return this.$dayjs(this.event.start_at).format('HH:mm:ss')
    },
    placeholderEnd() {
      return this.$dayjs(this.event.end_at).format('HH:mm:ss')
    }
  },
  watch: {
  },
  methods: {
    formatStop() {
      if (!this.exercise.exercise_stop_at || !this.$dayjs(this.exercise.exercise_stop_at, ['HH:mm:ss', 'HH:mm']).isValid()) return

      this.exercise.exercise_stop_at = this.$dayjs(this.exercise.exercise_stop_at, ['HH:mm:ss', 'HH:mm']).format('HH:mm:ss')

      this.adjustStop()
    },
    formatStart() {
      if (!this.exercise.exercise_start_at || !this.$dayjs(this.exercise.exercise_start_at, ['HH:mm:ss', 'HH:mm']).isValid()) return

      this.exercise.exercise_start_at = this.$dayjs(this.exercise.exercise_start_at, ['HH:mm:ss', 'HH:mm']).format('HH:mm:ss')

      this.adjustStop()
    },
    adjustStop() {
      const startAt = this.$dayjs(this.exercise.exercise_start_at, ['HH:mm:ss', 'HH:mm'])
      const stopAt = this.$dayjs(this.exercise.exercise_stop_at, ['HH:mm:ss', 'HH:mm'])

      if (!startAt.isValid() || !stopAt.isValid()) return

      if (stopAt.isBefore(startAt)) this.exercise.exercise_stop_at = startAt.add(1, 'minute').format('HH:mm:ss')
    }
  }
}
</script>
